/**
 * 过程性考核(processAssess)子系统 URL 配置
 * 数据来源: build/env.config.js (通过 webpack DefinePlugin 注入)
 */
const cfg = JSON.parse(process.env.ENV_CONFIG || '{}')

export default {
  url: cfg.api && cfg.api.processAssess,
  pageUrl: cfg.pageBaseUrl || {},
  imgUrl: cfg.imgUrl,
  studentPageBaseUrl: {
    online: cfg.studentPage,
  },
}



// WEBPACK FOOTER //
// ./src/fetch/url_processAssess.js